import React from 'react';
import PropTypes from 'prop-types';
import UpIcon from '@material-ui/icons/KeyboardArrowUp';
import Button from '@material-ui/core/Button';
import Slide from '@material-ui/core/Slide';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles({
	root: {
		position: 'fixed',
		right: 20,
		bottom: 20,
		width: 60,
		height: 60,
		zIndex: 1000,
		borderRadius: 100,
	},
});

const ScrollButton = ({open, action}) => {
	const classes = useStyles();

	return (
		<Slide in={open} direction='up'>
			<Button color='primary' variant='contained' className={classes.root} onClick={action}>
				<UpIcon fontSize='large' />
			</Button>
		</Slide>
	);
};

ScrollButton.propTypes = {
	open: PropTypes.bool,
	action: PropTypes.func,
};

export default ScrollButton;
